"use client";

import TestimonialsSlider from "@/components/testimonials-slider";
import { Navigation } from "swiper/modules";
import SectionTitle from "./section-title";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import { useTranslations } from "next-intl";

export const testimonials = [
  {
    name: "Indra Wijaya",
    company: "Tech Innovators",
    comment: "testimonials.indra.comment",
    image: "/testimonials/indra.png",
    rating: 5,
  },
  {
    name: "Sarah Johnson",
    company: "Creative Minds",
    comment: "testimonials.sarah.comment",
    image: "/testimonials/sarah.png",
    rating: 4,
  },
  {
    name: "Faisal Hakim",
    company: "Global Ventures",
    comment: "testimonials.faisal.comment",
    image: "/testimonials/faisal.png",
    rating: 5,
  },
  {
    name: "Emily Brown",
    company: "Startup Hub",
    comment: "testimonials.emily.comment",
    image: "/testimonials/emily.png",
    rating: 4,
  },
  {
    name: "Lia Setiawan",
    company: "Bright Future",
    comment: "testimonials.lia.comment",
    image: "/testimonials/5.png",
    rating: 5,
  },
  {
    name: "David Lee",
    company: "NextGen Solutions",
    comment: "testimonials.david.comment",
    image: "/testimonials/6.png",
    rating: 5,
  },
];

const SectionTestimonialsSlider = () => {
  const t = useTranslations("SectionTestimonials");

  return (
    <section className="bg-secondary py-24">
      <div className="container max-w-6xl">
        <SectionTitle
          subtitle={t("subtitle")}
          sectionClasses="mb-12"
          titleClasses="mb-3 text-white"
          subtitleClasses="text-md font-medium text-white"
        >
          {t("title")}
        </SectionTitle>
        <TestimonialsSlider
          testimonials={testimonials.map((testimonial) => ({
            ...testimonial,
            comment: t(testimonial.comment),
          }))}
          swiperParams={{
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1025: {
                slidesPerView: 2,
              },
            },
            spaceBetween: 40,
            modules: [Navigation],
          }}
        />
      </div>
    </section>
  );
};

export default SectionTestimonialsSlider;
